// ENTITY fr.gestionpial.pial.dto.DashboardReserveAeshDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';

export class DashboardReserveAeshDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.DashboardReserveAeshDTO';

  idAesh: number | null = 0;
  nom: string | null = '';
  prenom: string | null = '';
  ecoleNom: string | null = '';
  reserveMinutes: number | null = 0;
  creneauxTexte: string | null = '';

  constructor(init?:Partial<DashboardReserveAeshDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.DashboardReserveAeshDTO'] = DashboardReserveAeshDTO;

fields['fr.gestionpial.pial.dto.DashboardReserveAeshDTO']  = {
    idAesh: 'java.lang.Integer',
    nom: 'java.lang.String',
    prenom: 'java.lang.String',
    ecoleNom: 'java.lang.String',
    reserveMinutes: 'java.lang.Integer',
    creneauxTexte: 'java.lang.String'
};
